<template>
  <div class="crop-info">
    <HeadedContainer>
      <template v-slot:header>
        {{$ml.get(`Crop info`)}}
      </template>
      <div class="form">
        <div class="item">
          <app-sel
            key-name="id"
            label-name="name"
            :label="$ml.get(`Crop`)"
            :items="sortedItems($store.getters['user-crops/data'].filter(el => {return el.owner == 0}))"
            v-model="form.cropId"
            @input="getVarieties(true)"
            :filterable="true"
          >
            <template v-slot="{ items }">
              <app-sel-opt v-for="item in items" :value="item" :key="item.id">
                
                {{ $ml.get(item.name) }}
              </app-sel-opt>
            </template>
          </app-sel>
        </div>

        <div class="item" v-if="!hide">
          <app-sel
            key-name="name"
            label-name="name"
            :label="$ml.get(`Type sampled`)"
            :items="sortedItems(varieties)"
            v-model="form.variety"
            @input="getTissues(true)"
            :disabled="!form.cropId"
          >
            <template v-slot="{ items }">
              <app-sel-opt v-for="item in items" :value="item" :key="item.key">
                {{ $ml.get(item.name) }}
              </app-sel-opt>
            </template>
          </app-sel>
        </div>

        <div class="item" v-if="!hide">
          <app-sel
            key-name="name"
            label-name="name"
            :label="$ml.get(`Tissue sampled`)"
            :items="sortedItems(tissues)"
            v-model="form.tissue"
            @input="getSamplingByTissue(true)"
            :disabled="!form.variety"
          >
            <template v-slot="{ items }">
              <app-sel-opt v-for="item in items" :value="item" :key="item.key">
                {{ $ml.get(item.name) }}
              </app-sel-opt>
            </template>
          </app-sel>
        </div>

        <div class="item" v-if="!hide">
          <app-sel
            key-name="name"
            label-name="name"
            :label="$ml.get(`Sampling time`)"
            :items="sortedItems(times)"
            v-model="form.samplingTime"
            @input="getTest"
            :disabled="!form.tissue"
          >
            <template v-slot="{ items }">
              <app-sel-opt v-for="item in items" :value="item" :key="item.key">
                {{ $ml.get(item.name) }}
              </app-sel-opt>
            </template>
          </app-sel>
        </div>

        <div v-if="hide" class="item to-types-found">
          {{$ml.get('No types are found for this crop')}}
        </div>

      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import { CropAPI, TissueTestAPI } from '@/api';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      tests: [],
      crops: [],
      varieties: [],
      tissues: [],
      times: [],
      hide: false
    }
  },
  watch: {
    /**
     * Следить когда выберут готовый тест или будут новый создавать
     * (после того как посетили готовый)
     */
    'form': function (to, from) {
      this.primaryLoadIfNeeded(to);
    }
  },
  components: {
    HeadedContainer,
  },
  methods: {

    sortedItems(array) {
      var result = [];
      var exist  = {};

      for(var i in array) {
        exist[array[i]['name'].toLowerCase()] = array[i];
      }

      for(i in exist) {
          result.push(exist[i]);
      }

      result = result.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)

      return result;
    },

    // sortedItems(array) {
    //   array = [...new Set(array.map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
    //   array = array.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)
    //   return array
    // },

    /**
     * Если уже выбран тест
     * то подгрузить все данные в селекты
     */
    primaryLoadIfNeeded(form) {

      if(form.id) {
        this.getVarieties();
        this.getTissues();
        this.getSamplingByTissue();
        this.getTest();
      }
    },

    async getVarieties(purge_chain = false) {

      if(purge_chain) {
        this.form.variety = null;
        this.form.tissue = null;
        this.form.samplingTime = null;
      }

      this.varieties = await TissueTestAPI.getTissueTest(
        this.form.cropId,
      ).then(res => {
        this.hide = false
        var data = Object.values(res.data.data);
        return data
          .map((n, i) => {
            return {
              name: n.variety,
              value: n.variety,
            }
          })
      }, rej => {
        this.hide = true
        console.clear()
      })
    },
    async getTissues(purge_chain = false) {

      if(purge_chain) {
        this.form.tissue = null;
        this.form.samplingTime = null;
      }

      this.tissues = await TissueTestAPI.getTissueByVariety(
        this.form.cropId,
        this.form.variety
      )
        .then(res => res.data.data.map((n, i) => {
          return {
            name: n.tissue,
            value: n.tissue,
          }
        }));
    },
    async getSamplingByTissue(purge_chain = false) {

      if(purge_chain) {
        this.form.samplingTime = null;
      }

      this.times = await TissueTestAPI.getSamplingByTissue(
        this.form.cropId,
        this.form.variety,
        this.form.tissue
      )
        .then(res => res.data.data.map((n, i) => {
          return {
            name: n.samplingTime,
            value: n.samplingTime,
          }
        }));
    },
    // TODO попросить кирилла передавать меньше данных , только tissueTestId
    async getTest() {
      const tests = await TissueTestAPI.getTissueTest(
        this.form.cropId,
        this.form.variety,
        this.form.tissue,
        this.form.samplingTime,
      ).then(res => res.data.data);

      if(tests[0]) {
        this.$store.commit('tests/tissue/setTest', tests[0]);
        this.form.tissueTestId = this.test.id;
      }
    },
  },
  computed: {
    ...mapGetters({
      form: 'tests/tissue/form',
      test: 'tests/tissue/test'
    })

  },
  created() {
    this.primaryLoadIfNeeded(this.form);
  }
}
</script>

<style lang="scss" scoped>

.to-types-found {
  font-size: 15px;
  color: red;
}

.form {
  width: 100%;
  padding-bottom: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  .item {
    // width: 33.3%;
    width: 50%;
    padding: 0 10px;
    margin-top: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      width: 100%;
    }
  }
}

</style>
